import React from 'react';
import { Button } from '@polichat/flamboyant';
import { useGlotaT } from 'src/hooks/useGlotaTranslation';

import Illustration from '../../../../../../assets/images/illustrations/illustration-welcome-waba-channel.svg';
import { Container } from './Congratulations.styles';

interface Props {
  onUpdate: () => void;
}

const Congratulations = ({ onUpdate }: Props) => {
  const congratulationsTitle = useGlotaT('spa.certification.congratulationsTitle');
  const congratulationsComplete = useGlotaT('spa.certification.congratulationsComplete');

  return (

  <div data-tour={'HelpHero_Migrate_WhatsApp_Step05'}>
    <Container>
      <img
        src={Illustration}
        alt="Canal adicionado"
      />
      <h2>{congratulationsTitle}</h2>
      <Button
        gradient="primary"
        width="total"
        onClick={() => {
          onUpdate();
        }}
      >
        {congratulationsComplete}
      </Button>
    </Container>
    </div>
  );
};

export default Congratulations;
